export const DELETE_EMPLOYEE_SUCCESS = 'DELETE_EMPLOYEE_SUCCESS';

export const deleteEmployeeSuccess = (id) => ({
    type: DELETE_EMPLOYEE_SUCCESS,
    payload: { id },
});
